import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import expressIcon from '../../assets/images/about/express.png';
import happyIcon from '../../assets/images/about/happy.png';
import ecoIcon from '../../assets/images/about/eco.png';
import qualifiedIcon from '../../assets/images/about/qualified.png';
import qualityIcon from '../../assets/images/about/quality.png';
import warrantyIcon from '../../assets/images/about/warranty.png';

const values = [
  { icon: expressIcon, title: 'Express Repairs', desc: 'Most repairs completed same day while you wait — no long turnarounds.' },
  { icon: happyIcon, title: 'Customer Satisfaction', desc: 'Over 50,000 satisfied customers across the UK and still growing.' },
  { icon: ecoIcon, title: 'Eco Friendly', desc: 'Committed to sustainable and responsible device repair practices.' },
  { icon: qualifiedIcon, title: 'Qualified Technicians', desc: 'Fully certified and experienced repair specialists at every store.' },
  { icon: qualityIcon, title: 'Quality Assured', desc: 'Premium parts, rigorous quality checks, and full functional testing.' },
  { icon: warrantyIcon, title: 'Warranty Protected', desc: 'Up to lifetime warranty on select iPhone screen repairs.' },
];

const timeline = [
  { year: '2015', title: 'Founded', desc: 'Phone Clinic 4U started with a single store, dedicated to quality mobile repairs.' },
  { year: '2018', title: 'UK Expansion', desc: 'Expanded to 5 stores across England and Scotland, building a trusted brand.' },
  { year: '2021', title: 'Going National', desc: 'Grew to 10+ locations, becoming one of the UK\'s largest repair networks.' },
  { year: '2024', title: 'Today', desc: '15+ stores nationwide, 50,000+ happy customers — and still growing.' },
];

function Glow({ top, right, bottom, left, size = '400px', opacity = 0.1 }) {
  return (
    <div style={{
      position: 'absolute', top, right, bottom, left,
      width: size, height: size, borderRadius: '50%', pointerEvents: 'none',
      background: `radial-gradient(circle, rgba(198,21,21,${opacity}) 0%, transparent 70%)`,
    }} />
  );
}

function About() {
  return (
    <div style={{ background: '#080808', paddingTop: '78px' }}>

      {/* ── Hero ── */}
      <section style={{
        minHeight: '52vh',
        background: 'linear-gradient(135deg, #0d0d0d 0%, #110404 100%)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        position: 'relative', overflow: 'hidden', padding: '70px 5%',
      }}>
        <Glow top="-20%" right="-5%" size="500px" opacity={0.12} />
        <Glow bottom="-30%" left="-8%" size="380px" opacity={0.07} />
        <div style={{
          position: 'absolute', inset: 0, pointerEvents: 'none',
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.012) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.012) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }} />
        <motion.div
          initial={{ opacity: 0, y: 34 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
          style={{ textAlign: 'center', position: 'relative', zIndex: 1 }}
        >
          <div style={{ fontSize: '11px', letterSpacing: '4px', color: '#c61515', fontWeight: '800', marginBottom: '18px' }}>
            WHO WE ARE
          </div>
          <h1 style={{ color: 'white', fontSize: 'clamp(34px, 5.5vw, 62px)', fontWeight: '900', margin: '0 0 22px', lineHeight: '1.1' }}>
            About{' '}
            <span style={{
              background: 'linear-gradient(135deg, #dd4d4e 0%, #c61515 50%, #780e0f 100%)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
            }}>
              Phone Clinic
            </span>
          </h1>
          <p style={{ color: '#777', fontSize: '15px', maxWidth: '560px', margin: '0 auto', lineHeight: '1.85' }}>
            UK's trusted mobile phone repair and sales specialists, serving communities across England and Scotland since 2015.
          </p>
        </motion.div>
      </section>

      {/* ── Story + Timeline ── */}
      <section style={{ padding: '100px 5%', background: '#080808' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', gap: '80px', flexWrap: 'wrap', alignItems: 'flex-start' }}>

          {/* Left — copy */}
          <motion.div
            initial={{ opacity: 0, x: -40 }} whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.6 }}
            style={{ flex: '1', minWidth: '280px' }}
          >
            <div style={{ fontSize: '11px', letterSpacing: '4px', color: '#c61515', fontWeight: '800', marginBottom: '16px' }}>
              OUR STORY
            </div>
            <h2 style={{ color: 'white', fontSize: 'clamp(26px, 3.5vw, 36px)', fontWeight: '900', margin: '0 0 28px', lineHeight: '1.2' }}>
              Trusted by Thousands<br />
              <span style={{ color: '#c61515' }}>Across the UK</span>
            </h2>
            {[
              'Phone Clinic 4 U is a UK based, successful and growing mobile phone sales and Services Company that specializes in bringing its customers with the latest phones on the market and their accessories along with other services.',
              'We have stores located all over the country that strive to provide our customers with quality services such as mobile phone unlocking and phone repairs. Our goal is to be the ultimate one stop shop for any and all mobile phones and mobile accessories.',
              'With numerous retail centres, Phone Clinic 4 U is easily accessible and has quickly become a preferred retail outlet for customers for mobile devices, parts, accessories, services and repairs.',
              'Phone Clinic 4 U\'s success stems from our dedication to always providing our customers with quality products and dedicated services. We aim to treat each customer with care, putting in extra effort to ensure full satisfaction.',
            ].map((para, i) => (
              <p key={i} style={{ color: '#777', fontSize: '14px', lineHeight: '1.85', margin: '0 0 18px' }}>
                {para}
              </p>
            ))}
            <Link to="/services" style={{ textDecoration: 'none' }}>
              <motion.button
                whileHover={{ scale: 1.05, boxShadow: '0 0 28px rgba(198,21,21,0.5)' }}
                whileTap={{ scale: 0.95 }}
                style={{
                  background: 'linear-gradient(135deg, #c61515, #780e0f)',
                  color: 'white', border: 'none', padding: '12px 28px',
                  borderRadius: '9px', fontSize: '12px', letterSpacing: '1.8px',
                  fontWeight: '800', cursor: 'pointer', fontFamily: 'Catamaran, sans-serif',
                  marginTop: '8px',
                }}
              >
                BOOK A REPAIR
              </motion.button>
            </Link>
          </motion.div>

          {/* Right — timeline */}
          <div style={{ flex: '1', minWidth: '260px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
            {timeline.map((item, i) => (
              <motion.div
                key={item.year}
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0, transition: { delay: i * 0.1, duration: 0.55 } }}
                viewport={{ once: true }}
                whileHover={{ x: 6, borderColor: 'rgba(198,21,21,0.4)' }}
                transition={{ duration: 0.25 }}
                style={{
                  background: 'rgba(255,255,255,0.028)',
                  border: '1px solid rgba(255,255,255,0.07)',
                  borderRadius: '14px', padding: '22px 24px',
                  display: 'flex', gap: '22px', alignItems: 'flex-start',
                }}
              >
                <div style={{
                  fontSize: '24px', fontWeight: '900', color: '#c61515',
                  minWidth: '64px', lineHeight: '1',
                }}>
                  {item.year}
                </div>
                <div>
                  <h5 style={{ color: 'white', fontSize: '15px', fontWeight: '800', margin: '0 0 5px' }}>
                    {item.title}
                  </h5>
                  <p style={{ color: '#666', fontSize: '13px', margin: 0, lineHeight: '1.65' }}>
                    {item.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Values Grid ── */}
      <section style={{
        padding: '100px 5%',
        background: '#0c0c0c',
        borderTop: '1px solid rgba(198,21,21,0.1)',
      }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.6 }}
          style={{ textAlign: 'center', marginBottom: '64px' }}
        >
          <div style={{ fontSize: '11px', letterSpacing: '4px', color: '#c61515', fontWeight: '800', marginBottom: '14px' }}>
            WHAT DRIVES US
          </div>
          <h2 style={{ color: 'white', fontSize: 'clamp(26px, 4vw, 36px)', fontWeight: '900', margin: '0 0 18px' }}>
            Our <span style={{ color: '#c61515' }}>Core Values</span>
          </h2>
          <div style={{ width: '50px', height: '3px', background: 'linear-gradient(90deg, #c61515, #780e0f)', margin: '0 auto' }} />
        </motion.div>

        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: '20px', maxWidth: '1200px', margin: '0 auto',
        }}>
          {values.map((v, i) => (
            <motion.div
              key={v.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0, transition: { delay: i * 0.08, duration: 0.5 } }}
              viewport={{ once: true }}
              whileHover={{ y: -8, borderColor: 'rgba(198,21,21,0.4)' }}
              transition={{ duration: 0.3 }}
              style={{
                background: 'rgba(255,255,255,0.028)',
                border: '1px solid rgba(255,255,255,0.07)',
                borderRadius: '16px', padding: '32px 24px', textAlign: 'center',
              }}
            >
              <img
                src={v.icon} alt={v.title}
                style={{
                  width: '58px', height: '58px', objectFit: 'contain', marginBottom: '18px',
                  filter: 'drop-shadow(0 0 14px rgba(198,21,21,0.38))',
                }}
              />
              <h4 style={{ color: 'white', fontSize: '17px', fontWeight: '800', margin: '0 0 9px' }}>{v.title}</h4>
              <p style={{ color: '#666', fontSize: '13px', margin: 0, lineHeight: '1.65' }}>{v.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default About;
